import api from './api';

const extractData = (data) => {
  if (data && typeof data === 'object' && data.$values) {
    return data.$values;
  }
  return data;
};

const professionalServicePaymentsService = {
  // Retorna todos os combos selecionados por um profissional
  // MIGRATED: /professionalservicepayments/by-professional/{id} → /professionals/{id}/service-payments
  getByProfessionalId: async (professionalId) => {
    const response = await api.get(`/professionals/${professionalId}/service-payments`);
    return extractData(response.data);
  },

  // Retorna combos disponíveis para o profissional selecionar (do local onde ele atua)
  // MIGRATED: /professionalservicepayments/by-professional/{id}/available → /professionals/{id}/service-payments/available
  getAvailableForProfessional: async (professionalId) => {
    const response = await api.get(`/professionals/${professionalId}/service-payments/available`);
    return extractData(response.data);
  },

  // Buscar por ID
  // MIGRATED: /professionalservicepayments/{id} → /professionals/{professionalId}/service-payments/{id}
  getById: async (professionalId, id) => {
    const response = await api.get(`/professionals/${professionalId}/service-payments/${id}`);
    return extractData(response.data);
  },

  // Criar seleção de combo (profissional seleciona combo do place)
  // MIGRATED: /professionalservicepayments → /professionals/{professionalId}/service-payments
  create: async (professionalId, data) => {
    const response = await api.post(`/professionals/${professionalId}/service-payments`, data);
    return extractData(response.data);
  },

  // Criar múltiplas seleções de combo (bulk)
  // MIGRATED: /professionalservicepayments/bulk → /professionals/{professionalId}/service-payments/bulk
  createBulk: async (professionalId, data) => {
    const response = await api.post(`/professionals/${professionalId}/service-payments/bulk`, data);
    return extractData(response.data);
  },

  // Atualizar seleção (customizar preço/duração)
  // MIGRATED: /professionalservicepayments/{id} → /professionals/{professionalId}/service-payments/{id}
  update: async (professionalId, id, data) => {
    const response = await api.put(`/professionals/${professionalId}/service-payments/${id}`, data);
    return extractData(response.data);
  },

  // Deletar seleção (profissional remove combo)
  // MIGRATED: /professionalservicepayments/{id} → /professionals/{professionalId}/service-payments/{id}
  delete: async (professionalId, id) => {
    const response = await api.delete(`/professionals/${professionalId}/service-payments/${id}`);
    return response.data;
  },
};

export default professionalServicePaymentsService;
